var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRefresh(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00008 1C4.13604 1 1 4.13604 1 8.00008C1 11.8641 4.13604 15.0002 8.00008 15.0002C11.8641 15.0002 15.0002 11.8641 15.0002 8.00008C15.0002 4.13604 11.8641 1 8.00008 1ZM8.04208 12.9001V11.4931H8.00008C7.10407 11.4931 6.20806 11.1501 5.52205 10.4711C4.95227 9.90073 4.5966 9.15133 4.51499 8.34926C4.43338 7.54719 4.63083 6.74151 5.07405 6.06806L5.84406 6.83807C5.34705 7.76908 5.47305 8.94509 6.25706 9.7291C6.74707 10.2191 7.39107 10.4501 8.03508 10.4361V8.93809L10.0161 10.9191L8.04208 12.9001ZM10.9191 9.9321L10.1491 9.1621C10.6461 8.23108 10.5201 7.05507 9.7361 6.27106C9.50887 6.04195 9.2384 5.86024 8.94039 5.73647C8.64239 5.6127 8.32277 5.54934 8.00008 5.55005H7.95808V7.05507L5.97706 5.08105L7.95808 3.10002V4.51404C8.86809 4.50004 9.7851 4.82904 10.4781 5.52905C11.6681 6.71907 11.8151 8.57409 10.9191 9.9321Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.cb122ff7b918a06b74c3c0217d96cc39.svg";
export { ForwardRef as ReactComponent };